<!-- Log In page -->
<div class="row vh-100 ">
    <div class="col-12 align-self-center">
        <div class="auth-page">
            <div class="card auth-card shadow-lg">
                <div class="card-body">
                    <div class="px-3">
                        <div class="auth-logo-box">
                            <a href="/" class="logo logo-admin"><img src="./assets/images/logo-sm.png" height="55" alt="logo" class="auth-logo"></a>
                        </div><!--end auth-logo-box-->

                        <div class="text-center auth-logo-text">
                            <h4 class="mt-0 mb-3 mt-5" i18n>Password recovery</h4>
                            <p class="text-muted mb-0" i18n>Set new passord for your account.</p>
                        </div> <!--end auth-logo-text-->


                        <form class="form-horizontal auth-form my-4" [formGroup]="doPasswordResetForm" (ngSubmit)="onSubmit()">

                            <div class="form-group">
                                <label for="useremail">New password</label>
                                <div class="input-group mb-3">
                                    <span class="auth-form-icon">
                                        <fa-icon [icon]="faLock"></fa-icon>
                                    </span>
									<div class="p-fluid" style="width: 100%;">
									<p-password inputStyleClass="form-control p-password-input {{(!f.password.untouched && f.password.errors ? 'is-invalid' : '')}}" placeholder="Enter password" i18n-weakLabel weakLabel="Weak" i18n-mediumLabel mediumLabel="Middle" i18n-strongLabel strongLabel="Strong" formControlName="password" autocomplete="new-password">
										<ng-template pTemplate="footer">
										  <p-divider></p-divider>
										  <p class="mt-2" i18n>Suggestions</p>
										  <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
											<li i18n>At least one lowercase</li>
											<li i18n>At least one uppercase</li>
											<li i18n>At least one numeric</li>
											<li i18n>Minimum 8 characters</li>
										  </ul>
										</ng-template>
									  </p-password>
									</div>
									  <span [ngClass]="{ 'is-invalid': !f.password.untouched && f.password.errors }"></span>
										<div *ngIf="f.password.errors" class="invalid-feedback">
										<div *ngIf="!f.password.untouched && f.password.errors.required" i18n>Password is required.</div>
										<div *ngIf="f.password.value !== '' && !f.password.untouched && f.password.errors.invalidPasswordLevel">
											<span i18n>Password has to be atleast of midle complexity, try to adding numbers or special characters to it.</span>
										</div>
									</div>
                                </div>
                            </div><!--end form-group-->
							<div class="form-group">
                                <label for="useremail">New password again</label>
                                <div class="input-group mb-3">
                                    <span class="auth-form-icon">
                                        <fa-icon [icon]="faLock"></fa-icon>
                                    </span>
									<div class="p-fluid" style="width: 100%;">
									<p-password inputStyleClass="form-control p-password-input {{((!f.repeatPassword.untouched && f.repeatPassword.errors || f.repeatPassword.value !== '' && !f.repeatPassword.untouched && doPasswordResetForm.hasError('notSame'))? 'is-invalid' : '')}}" placeholder="Enter password" i18n-weakLabel weakLabel="Weak" i18n-mediumLabel mediumLabel="Middle" i18n-strongLabel strongLabel="Strong" formControlName="repeatPassword" autocomplete="new-password">
										<ng-template pTemplate="footer">
										  <p-divider></p-divider>
										  <p class="mt-2" i18n>Suggestions</p>
										  <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
											<li i18n>At least one lowercase</li>
											<li i18n>At least one uppercase</li>
											<li i18n>At least one numeric</li>
											<li i18n>Minimum 8 characters</li>
										  </ul>
										</ng-template>
									  </p-password>
									</div>
									  <span [ngClass]="{ 'is-invalid': (!f.repeatPassword.untouched && f.repeatPassword.errors || f.repeatPassword.value !== '' && !f.repeatPassword.untouched && doPasswordResetForm.hasError('notSame')) }"></span>
								  <div *ngIf="f.repeatPassword.errors" class="invalid-feedback">
									<div *ngIf="!f.repeatPassword.untouched && f.repeatPassword.errors.required" i18n>Password again is required.</div>
									<div *ngIf="f.repeatPassword.value !== '' && !f.repeatPassword.untouched && f.repeatPassword.errors.invalidPasswordLevel">
									  <span i18n>Password has to be atleast of midle complexity, try to adding numbers or special characters to it.</span>
									</div>
								  </div>
								  <div class="invalid-feedback" *ngIf="f.repeatPassword.value !== '' && !f.repeatPassword.untouched && doPasswordResetForm.hasError('notSame')">
									<span i18n>Passwords does not match.</span>
								  </div>
                                </div>
                            </div><!--end form-group-->


                            <div class="form-group mb-0 row">
                                <div class="col-12 mt-2">
									<button pButton pRipple type="submit" i18n-label label="Change password" [disabled]="doPasswordResetForm.invalid" [loading]="loading" class="p-button-rounded"></button>
                                </div><!--end col-->
                            </div> <!--end form-group-->
                        </form><!--end form-->
                    </div><!--end /div-->

                    <div class="m-3 text-center text-muted">
                        <p><span i18n>Did you just remembered?</span><a [routerLink]="['/auth', 'sign-in']" class="text-primary ml-2" i18n>Sign in here</a></p>
                    </div>
                </div><!--end card-body-->
            </div><!--end card-->
        </div><!--end auth-page-->
    </div><!--end col-->
</div><!--end row-->
<!-- End Log In page -->